import { render } from "./TradesTablePVT.vue?vue&type=template&id=6240ceaa&scoped=true"
import script from "./TradesTablePVT.vue?vue&type=script&lang=js"
export * from "./TradesTablePVT.vue?vue&type=script&lang=js"

import "./TradesTablePVT.vue?vue&type=style&index=0&id=6240ceaa&scoped=true&lang=scss"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6240ceaa"]])

export default __exports__